<template>
  <div>
    <SiteHeader bg="false"></SiteHeader>
    <home-callout />
    <home-hero />
    <home-what-we-do />
    <home-about />
    <case-studies-index standalone="true" />
    <SiteFooter></SiteFooter>
  </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import HomeHero from '@/components/HomeHero.vue';
import HomeWhatWeDo from '@/components/HomeWhatWeDo.vue';
import HomeAbout from '@/components/HomeAbout.vue';
import CaseStudiesIndex from '@/components/CaseStudiesIndex.vue';
import SiteFooter from '@/components/Footer.vue';
import HomeCallout from '@/components/HomeCallout.vue';
// SVG
import '@/components/svg/icon-projects';
import '@/components/svg/icon-location';
import '@/components/svg/icon-people';
import '@/components/svg/icon-team';
import '@/components/svg/icon-roi';
export default {
  name: 'Home',
  components: {
    SiteHeader,
    HomeHero,
    HomeWhatWeDo,
    HomeAbout,
    CaseStudiesIndex,
    SiteFooter,
    HomeCallout
  },
  props: ['scrollTo'],
  mounted: function() {
    if (this.scrollTo) {
      let anchor = this.scrollTo.replace(/-/g, '');
      this.$SmoothScroll(document.getElementById(anchor), 800, null, null, 'y');
    }
  }
};
</script>

<style lang="scss"></style>
